export const getTitleTop = (
	isDashboardDetail: boolean | undefined,
	isMissingValueWithItems: boolean,
) => {
	if (isDashboardDetail) {
		return "60px";
	}

	if (isMissingValueWithItems) {
		return "50px";
	}

	return "66px";
};

export const getNetValueTop = (
	isDashboardDetail: boolean | undefined,
	isMissingValueWithItems: boolean,
) => {
	if (isDashboardDetail) {
		return "126px";
	}

	if (isMissingValueWithItems) {
		return "140px";
	}

	return "132px";
};
